import { IconId, getIconId } from '@src/main/ui/components/common/Icon/IconId';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';

export interface SubMenuItem {
  text: string;
  url: string;
}

export interface NavbarItem {
  icon?: IconId;
  text: string;
  onClick: () => void;
  isActive: () => boolean;
  mobileOnly?: boolean;
  hideMobile?: boolean;
  menuItems?: SubMenuItem[];
}

export interface NavbarItems {
  main: NavbarItem[];
  areas: NavbarItem[];
}

const useNavbarItems = (): NavbarItems | undefined => {
  const navigate = useNavigate();
  const location = useLocation();
  const { areas } = useAreaContext();

  if (!areas) {
    return undefined;
  }

  const areasNavbarItems: NavbarItem[] = areas
    .map((area) => ({
      icon: getIconId(area.name),
      text: area.name,
      onClick: () => {},
      isActive: () => false,
      menuItems: area.subareas
        .map((subarea) => ({
          text: subarea.name,
          url: `/areas/${area.id}/${subarea.id}`,
        }))
        .sort((a, b) => a.text.localeCompare(b.text)),
    }))
    .sort((a, b) => {
      const order = ['Airline', 'MRO', 'Handling', 'Central Services'];
      return order.indexOf(a.text) - order.indexOf(b.text);
    });

  return {
    main: [
      {
        icon: 'home',
        text: 'Home',
        onClick: () => navigate('/'),
        isActive: () => location.pathname === '/',
      },
      {
        icon: 'search',
        text: 'Search',
        onClick: () => navigate('/search'),
        isActive: () => location.pathname === '/search',
      },
      {
        icon: 'favorites',
        text: 'Favorites',
        onClick: () => navigate('/favorites'),
        isActive: () => location.pathname === '/favorites',
      },
      {
        icon: 'areas',
        text: 'Areas',
        onClick: () => navigate('/areas-menu'),
        isActive: () => location.pathname === '/areas-menu',
        mobileOnly: true,
      },
    ],
    areas: [...areasNavbarItems],
  };
};

export default useNavbarItems;
